import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ReactDOM from 'react-dom';
import './ImageVisualizer.css';

const ImageVisualizer = ({ imageUrl, onClose }) => {
    const modalRef = useRef(null);
    
    useEffect(() => {
        // Focus trap and handle escape key
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        
        // Prevent body scrolling when modal is open
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'auto';
        };
    }, [onClose]);

    const handleBackdropClick = (e) => {
        // Close when clicking on backdrop, not on modal content
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    // Use portal to render directly to document body
    return ReactDOM.createPortal(
        <div className="imagevisualizer-backdrop" onClick={handleBackdropClick}>
            <div className="imagevisualizer-modal" ref={modalRef}>
                <button className="imagevisualizer-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <div className="imagevisualizer-content">
                    <img 
                        src={imageUrl} 
                        alt="Visualization" 
                        className="imagevisualizer-image"
                    />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ImageVisualizer;
